import { Link } from "react-router-dom";
import { Card } from "primereact/card";
import Pills, { PillType, type PillTypeValue } from "../../components/controls/Pills";
import { formatDate, formatDateWithTime } from "../../shared/utility";
import type { OrderListItem, OrderStatus } from "../../types/orders";
import { getSalesOrderNumber } from "../../shared/orderNumbers";

interface OrdersCardsForMobileProps {
  askDeleteOrder: (order: OrderListItem) => void;
  orders: { data: OrderListItem[] };
}
const statusContent: Record<OrderStatus, { text: string; type: PillTypeValue }> = {
  1: { text: "Created", type: PillType.Warning },
  3: { text: "Shipped", type: PillType.Success },
  8: { text: "Void", type: PillType.Error },
  9: { text: "Backordered", type: PillType.DarkYellow },
};

export default function OrdersCardsForMobile(props: OrdersCardsForMobileProps) {
  const { askDeleteOrder, orders } = props;

  return (
    <div className="block lg:hidden space-y-4 p-4">
      {orders.data && orders.data.length > 0 ? (
        orders.data.map((order) => (
          <Card
            key={order.id}
            className="cursor-pointer apollo-card hover:shadow-md transition-shadow duration-200"
            style={{ backgroundColor: "white" }}
            onClick={() => { window.location.href = `/orders/${order.id}`; }}
          >
            <div className="flex flex-col space-y-3">
              {/* Header */}
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="text-h6 apollo-heading text-primary-600 mb-1">
                    {getSalesOrderNumber(order)}
                  </h3>
                  <p className="text-body-2 apollo-subheading">{order.company_name}</p>
                </div>
                <Pills content={statusContent[order.status]} />
              </div>

              {/* Order Details */}
              <div className="space-y-2">
                <div className="flex justify-between text-body-2 apollo-body">
                  <span>Order Date:</span>
                  <span>{formatDateWithTime(order.created_at)}</span>
                </div>
                {order.expected_date && (
                  <div className="flex justify-between text-body-2 apollo-body">
                    <span>Expected Delivery:</span>
                    <span>{formatDate(order.expected_date)}</span>
                  </div>
                )}
                <div className="flex justify-between text-body-2 apollo-subheading text-primary-700 border-t pt-2">
                  <span>Total Amount:</span>
                  <span>${order.total_dollar_amount}</span>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-2 pt-2" onClick={(e) => e.stopPropagation()}>
                <Link to={`/orders/${order.id}`} className="flex-1">
                  <button className="w-full inline-flex items-center justify-center px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-lg shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2">
                    Edit
                  </button>
                </Link>
                <button
                  onClick={() => askDeleteOrder(order)}
                  className="flex-1 inline-flex items-center justify-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                >
                  Delete
                </button>
              </div>
            </div>
          </Card>
        ))
      ) : (
        <Card className="apollo-card" style={{ backgroundColor: "white" }}>
          <div className="text-center py-8">
            <p className="text-body-1 apollo-body">No orders found</p>
          </div>
        </Card>
      )}
    </div>
  );
}
